



































































































































































































































































// import Vue from 'vue'
// import Component from 'vue-class-component'

import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
// import { Getter, Mutation } from 'vuex-class'


import DigitalCurrency1DigitalCurrencySymbol from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-1-digital-currency-symbol.vue'
// import DigitalCurrency2SendPaymentButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-2-send-payment-button.vue'
import DigitalCurrency6AccountUserProfilePicture from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-6-account-user-profile-picture.vue'
// import DigitalCurrency7AccountBalanceNumberWithIcon from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-7-account-balance-number-with-icon.vue'
// import DigitalCurrency9AccountShortIntroductionButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-9-account-short-introduction-button.vue'
// import DigitalCurrency11QrCodeScannerButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-11-qr-code-scanner-button.vue'
// import DigitalCurrency15AccountSettingsButton from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-15-account-settings-button.vue'

// import Groups1AddToGroupButton from '../../../../html-components-type-1-basic/basic-type-5-groups/groups-1-add-to-group-button.vue'


import DigitalCurrency5AccountThumbnail from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-5-account-thumbnail.vue'


import { projectVariables } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'


// const namespace = 'digitalCurrency'


@Component({
  components: {
    DigitalCurrency5AccountThumbnail,
    DigitalCurrency1DigitalCurrencySymbol,
    // DigitalCurrency2SendPaymentButton,
    DigitalCurrency6AccountUserProfilePicture
    // DigitalCurrency7AccountBalanceNumberWithIcon,
    // DigitalCurrency9AccountShortIntroductionButton,
    // DigitalCurrency11QrCodeScannerButton,
    // DigitalCurrency15AccountSettingsButton,
    // Groups1AddToGroupButton
  }
})
class CurrencyExchangeTradeHelperComponents2Header extends Vue {

  @Prop({ default: '' }) transactionId?: string

  temporaryImageUrl: string = 'https://ecoin-static-file-host.web.app/service-for-game-introduction/game-introduction-type-1-web-browser-introduction/web-browser-introduction-type-1-customer-website/public/img/icons/android-chrome-512x512.png'
  temporaryImageUrl2: string = 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fpixy.org%2Fsrc%2F21%2F219269.jpg&f=1&nofb=1'

  digitalCurrencyName = projectVariables.digitalCurrencyName

}

export default CurrencyExchangeTradeHelperComponents2Header
